import { type Context, createContext } from 'react';

/**
 * Exposes the BFF-driven `unitsRevampEnabled` value to sections the switcher
 * renders but does not own (e.g. the Post Office discovery section), so they
 * can opt into revamp behaviour via `SectionContainer` without consumers
 * threading the value through.
 */
export const UnitsRevampContext: Context<boolean> = createContext<boolean>(false);
